import * as _ from "lodash";

export class Field {
    public id: any = null;
    public name: any = null;
    public hokey: any = null;
    public cfid: any = null;
    public status: any = null;
    public order: any = null;
    public priority: any = null;
    public required: any = null;
    public timestamp: any = null;
    public cfcreator: any = null;
    public cftid: any = null;
    public type: any = null;
    public options: any = [];
    public is_nationbuilder: any = null;
    public nbslug: any = null;

    public checked?: boolean;
    public field_val?: any;
    public no_value?: boolean;
    public any_value?: boolean;
    public cfdefault?: any;
    public low_num?: any;
    public high_num?: any;
    public readonly?: any;
    public value?: any;
    public cfname?: any;
    public cftname?: any;
    public hocfvalue?: any;
    public option?: any;
    public nonpriority?: any;
    public orgid?: any;
    public columns?: any;
    public columncategory?: any;
    public columnname?: any;
    public columnid?: any;
    public elid?: any;
    public hocfid?: any;
    public files?: any[];
    public match_type?: string = "exact";
    public occupant_match?: "any" | "all" | "none" = "any";

    public dragDisabled?: boolean;
    public editDisabled?: boolean;
    public requiredAndReadOnlyDisabled?: boolean;

    constructor(data?: any) {
        this.setData(data);
    }

    setData(data?: any): void {
        if (data && data.attributes) {
            data.attributes.id = data.id;
            _.merge(this, data.attributes);
        } else {
            _.merge(this, data);
        }
    }

    optionsPopoverString(field: Field): string {
        let popover_string = "";
        for (let i = 0; i < field.options.length; i++) {
            popover_string += field.options[i].cfoname + ", ";
        }
        return popover_string.slice(0, -2);
    }

    isValid(): boolean {
        return this.name ? this.name.trim() !== "" : false;
    }
}
